import { SubGameType } from "types/game";

import { CATEGORY_CODE } from "./type";
import { ImgProvider } from "assets/desktop/images/navSubgame";
import { ProviderLogo } from "assets/desktop/images/providerList";

export const listLottery: SubGameType[] = [
  {
    game_code: "",
    name: "SUPER彩票",
    provider_code: "SPLT",
    provider_name: "SUPER lotery",
    type: CATEGORY_CODE.LOTTERY,
    featured: "",
    new_arrive: "",
    picture: ImgProvider.LotterySUPER,
    icon: ProviderLogo.LotterySUPER,
  },
  {
    game_code: "",
    name: "9k彩票",
    provider_code: "NK",
    provider_name: "9k lotery",
    type: CATEGORY_CODE.LOTTERY,
    featured: "",
    new_arrive: "",
    picture: ImgProvider.Lottery9K,
    icon: ProviderLogo.Lottery9K,
  },
  {
    game_code: "",
    name: "ATG",
    provider_code: "ATG",
    provider_name: "ATG lotery",
    type: CATEGORY_CODE.LOTTERY,
    featured: "",
    new_arrive: "",
    picture: ImgProvider.LotteryATG,
    icon: ProviderLogo.ATG,
  },
];
